module.exports = __webpack_public_path__ + "img/solution-ota-system-pic.2c554b64.png";